import { Input } from '@skytech/ui'
import type { FieldProps } from 'formik'
import { Field } from 'formik'

import { Translation } from '@/app/translations/Translation'

export const SddHuldtOgLillevik = () => (
  <>
    <div className="mt-3">
      <Field name="salaryDeductionCodeUsage">
        {({ field, meta }: FieldProps) => (
          <Input
            isFullWidth
            capitalizeLabel
            id="salaryDeductionCodeUsage"
            label={
              <>
                <Translation id="Accounting code device" />*
              </>
            }
            marginBottom={16}
            touched={meta.touched}
            error={meta.error}
            {...field}
          />
        )}
      </Field>
    </div>
    <div className="mt-3">
      <Field name="salaryDeductionCodeBuyout">
        {({ field, meta }: FieldProps) => (
          <Input
            isFullWidth
            capitalizeLabel
            id="salaryDeductionCodeBuyout"
            label={
              <>
                <Translation id="Accounting code buyout" />*
              </>
            }
            marginBottom={16}
            touched={meta.touched}
            error={meta.error}
            {...field}
          />
        )}
      </Field>
    </div>
    <div className="mt-3">
      <Field name="projectDevice">
        {({ field, meta }: FieldProps) => (
          <Input
            isFullWidth
            capitalizeLabel
            id="projectDevice"
            label={
              <>
                <Translation id="Project device" />*
              </>
            }
            marginBottom={16}
            touched={meta.touched}
            error={meta.error}
            {...field}
          />
        )}
      </Field>
    </div>
    <div className="mt-3">
      <Field name="departmentOverrideUsage">
        {({ field, meta }: FieldProps) => (
          <Input
            isFullWidth
            capitalizeLabel
            id="departmentOverrideUsage"
            label={
              <>
                <Translation id="Department override device	" />*
              </>
            }
            marginBottom={16}
            touched={meta.touched}
            error={meta.error}
            {...field}
          />
        )}
      </Field>
    </div>
  </>
)
